import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    AddCustomizeResourceParams, CustomizeResource, CustomizeResourceParams,
    CustomizeResourceWithPage,
    EditCustomizeResourceParams,
} from '@app/interfaces/rm/customize-resource';
import { SelectOption } from '@app/interfaces/sys/dict';
import { environment } from '@env/environment';
import { SettingsService } from '@services/sys/settings.service';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ResourceDefinitionsService {
    private baseUrl = environment.api.services.rm + '/resource-definitions';

    constructor(private http: HttpClient,
                private settingService: SettingsService) {
    }

    async find(params: CustomizeResourceParams): Promise<CustomizeResourceWithPage> {
        return lastValueFrom(this.http.get<CustomizeResourceWithPage>(`${this.baseUrl}`, {
            params: Object.assign(params),
        }));
    }

    async add(params: AddCustomizeResourceParams): Promise<void> {
        return lastValueFrom(this.http.post<void>(`${this.baseUrl}`, params));
    }

    async edit(data: EditCustomizeResourceParams): Promise<void> {
        return lastValueFrom(this.http.put<void>(`${this.baseUrl}`, data));
    }

    async delete(id: number): Promise<void> {
        return lastValueFrom(this.http.delete<void>(`${this.baseUrl}`, {
            params: Object.assign({ id }),
        }));
    }

    async findAllOptions(params: {type: string}): Promise<SelectOption[]> {
        return lastValueFrom(this.http.get<SelectOption[]>(`${this.baseUrl}/all-options`, {
            params: Object.assign(params)
        }))
    }

    async one(id: number): Promise<CustomizeResource> {
        return lastValueFrom(this.http.get<CustomizeResource>(`${this.baseUrl}/one`, {
            params: Object.assign({id}),
        }));
    }

    getCategoryList(): SelectOption[] {
        return [
            {
                label: 'Accessory',
                value: 'ACCESSORY',
            },
            {
                label: 'Physical',
                value: 'PHYSICAL',
            },
            {
                label: 'Software',
                value: 'SOFTWARE',
            },
        ];
    }

    hasSettingColumnsPermission(): boolean {
        return this.settingService.hasPermission(['Setting Resource Columns']);
    }
}

